import { SubscriptionService } from '../services/subscription.service';
import { Component, OnInit } from '@angular/core';
import QRCode from 'qrcode';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit {

    // title = 'foodmine-course';
    idSenha = '0'; // <<== Usar sempre isso
    guiche = '0'; // <<== Usar sempre isso
    // notificationTitle = 'Nova notificação';
    // notificationMessage = 'Você tem uma nova mensagem!';
    qrCodeUrl!: string;

    constructor(private subscriptionService: SubscriptionService) { }

    ngOnInit() {
        // Gerar uma URL baseada no ID da senha
        this.qrCodeUrl = `/inscricao?ID=${this.idSenha}`;
    }

    generateQrCode() {
        const url = `https://www.e-transport-scania.com/inscricao?ID=${encodeURIComponent(this.idSenha)}`;
        console.log(url);
        
        QRCode.toDataURL(url, (err, qrCodeUrl) => {
          if (err) {
            console.error('Erro ao gerar QR Code', err);
          } else {
            const qrCodeElement = document.getElementById('qrcode');
            if (qrCodeElement) {
              qrCodeElement.innerHTML = `<img src="${qrCodeUrl}" alt="QR Code" />`;
            }
          }
        });
    }

    // Método para chamar o serviço e enviar a requisição
    // subscribe() {
    //     this.subscriptionService.requestPermissionAndSubscribe(this.idSenha,'teste');
    // }

    // sendNotification() {
    //     this.subscriptionService.sendNotification(this.idSenha, this.guiche).subscribe(
    //         (response) => {
    //             console.log('Notificação enviada com sucesso!', response);
    //         },
    //         (error) => {
    //             console.error('Erro ao enviar notificação:', error);
    //         }
    //     );
    // }
}
